<template>
  <div class="row" id="table-hover-animation">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Abiturientlar ro'yxati</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"><h5><b>Rasm</b></h5></th>
                  <th scope="col"><h5><b>Login</b></h5></th>
                  <th scope="col"><h5><b>FIO</b></h5></th>
                  <th scope="col"><h5><b>Ro'yxatdan o'tgan sana</b></h5></th>
                </tr>
                </thead>
                <transition name="fade" :duration="2000">
                  <tbody class="table-bordered" v-if="loaded">
                  <tr v-for="(userItem, index) in usersList">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>
                      <img :src="`${baseURL}${userItem.userPhoto}`" alt="" height="50" width="50" class="round">
                    </td>
                    <td>
                      {{ userItem.userName }}
                    </td>
                    <td>{{ userItem.firstName + ' ' + userItem.lastName + ' ' + userItem.middleName }}</td>
                    <td>{{ $moment(userItem.createDate).format('YYYY-MM-DD HH:ss') }}</td>
                  </tr>
                  </tbody>
                </transition>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-center" v-if="usersList.length > 0">
            <v-pagination v-model="currentPage" :classes="bootstrapPaginationClasses" :page-count="totalSize"/>
          </div>
        </div>
      </div>
    </div>
    <modal :modal="modal" @modal-closed="modal = false" :modal-size="sizeClass" :style-prop="modalStyleProp">
      <component
        v-if="modal && deleteApi === ''"
        :is="currentComponent"
        :user="user"
        @saved="getUsersList(currentPage - 1)"
      />
      <deleting-modal v-if="modal && deleteApi !== ''" :delete-api="deleteApi" @deleted="getUsersList(currentPage - 1)"/>
    </modal>
  </div>
</template>

<script>
import vPagination from 'vue-plain-pagination';
import Modal from "../../components/Modal";
import UserForm from "./UserForm";
import UserView from "./UserView";
import DeletingModal from "../../components/DeletingModal";
import {mapGetters} from "vuex";

export default {
  name: "user",
  components: {
    DeletingModal,
    UserForm,
    Modal,
    UserView,
    vPagination
  },
  data() {
    return {
      usersList: [],
      loaded: false,
      user: {},
      currentComponent: '',
      modal: false,
      sizeClass: '',
      modalStyleProp: 'width: 600px',
      deleteApi: '',
      totalSize: 1,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link',
      },
    }
  },
  methods: {
    getUsersList(skip = 0) {
      this.loaded = false;
      this.$api.get(`admin/Monitoring/AbitUserList?skip=${skip}&take=10`)
        .then(res => {
          if (!res.error) {
            this.usersList = res.result.data;
            this.totalSize = Math.ceil(res.result.total / 10);
          }
        })
        .catch(err => {

        })
        .finally(() => {
          this.loaded = true;
        })
    },
    viewUser(user) {
      this.currentComponent = 'UserView';
      this.user = user;
      this.modal = true;
      this.deleteApi = '';
      this.sizeClass = 'modal-lg';
    },
    addUser() {
      this.currentComponent = 'UserForm';
      this.user = this.createUserObject();
      this.modal = true;
      this.deleteApi = '';
      this.sizeClass = 'modal-lg';
    },
    editUser(user) {
      this.currentComponent = 'UserForm';
      this.user = this.createUserObject(user);
      this.modal = true;
      this.deleteApi = '';
      this.sizeClass = 'modal-lg';
    },
    deleteUser(id) {
      this.sizeClass = 'modal-sm';
      this.deleteApi = `admin/Management/user/${id}`;
      this.modal = true;
    },

    createUserObject(user = null) {
      if (user)
        return {
          id: user.id,
          login: user.userName,
          password: user.password,
          firstName: user.firstName,
          lastName: user.lastName,
          middleName: user.middleName,
          email: user.email,
          telefon: user.telefon,
          photoFile: null,
          photo: user.userPhoto,
          active: true,
          isAdmin: false,
          isTeacher: user.isTeacher,
          client_id: "1",
        };
      else
        return {
          id: 0,
          login: '',
          password: '',
          firstName: '',
          lastName: '',
          middleName: '',
          email: '',
          telefon: '',
          photoFile: '',
          active: true,
          isAdmin: false,
          isTeacher: false,
          client_id: "1",
        }
    },
  },
  computed: {
    ...mapGetters(['teacherFilesModalShow']),
  },
  watch: {
    currentPage() {
      this.getUsersList(this.currentPage - 1);
    },
    teacherFilesModalShow() {
      if (this.teacherFilesModalShow) {
        this.modalStyleProp = 'min-width: 1000px';
      } else {
        this.modalStyleProp = null;
      }
    }
  },
  created() {
    this.getUsersList();
  }
}
</script>

<style scoped>

</style>
